import styled from "@emotion/styled";
import { ThemeKey } from "@smartsheet/design-tokens";
import { ArrowDownIcon } from "@smartsheet/lodestar-icons";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { ChevronDownIcon } from "@smartsheet/ursa-icons";
import React from "react";
import { useTheme } from "../../../../theme/utils/useTheme";
import { selectV2Theme } from "../selectV2Theme";

const ToggleButtonLodestar = styled(ArrowDownIcon)`
    // Make this a bit smaller to account for the shared styles from ActionButton.
    position: relative;
    top: -2px;
    left: -2px;
`;

interface ToggleButtonWrapperProps {
    themeMode: RequiredThemeKeys;
}

const ToggleButtonWrapper = styled("span")<ToggleButtonWrapperProps>`
    // Make this a bit smaller to account for the shared styles from ActionButton.
    // margin: -4px;
    height: ${({ themeMode }) => selectV2Theme.actionButtons.buttonWrapperSize(themeMode)};
    width: ${({ themeMode }) => selectV2Theme.actionButtons.buttonWrapperSize(themeMode)};
`;

export const ToggleButtonIcon = () => {
    const { key } = useTheme();
    const themeMode = key as ThemeKey;
    return (
        <ToggleButtonWrapper themeMode={themeMode}>
            {(() => {
                if (themeMode.includes("ursa")) {
                    return <ChevronDownIcon size={16} />;
                } else {
                    return <ToggleButtonLodestar />;
                }
            })()}
        </ToggleButtonWrapper>
    );
};
